export default __webpack_public_path__ + "static/media/ashkaesthetics.30c66f5e.png";